import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const studentUserService = {
  getAllStudentUsers,
  getStudentUserRoles,
  searchStudentByEmail,
  statusChangeTerms,
  getAllStudents,
  get_student_paper_enrol_status_counts,
  get_student_paper_details ,
  get_paper_enroled_student_counts,
  get_assessment_student_details

};

async function getAllStudentUsers() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    return await fetch(`${config.oat_api_url}/user/students/`, requestOptions).then(APIHandler.handleResponse);
}

async function getStudentUserRoles() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };

    const response = await fetch(`${config.oat_api_url}/user/student/roles/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function searchStudentByEmail(email) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(
      config.azure_ad_config.apis.OAT.name
    ),
  };

  const response = await fetch(
    `${config.oat_api_url}/user/students/email/${email}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function statusChangeTerms(id) {
  let requestOptions = {
    method: "PUT",
    headers: APIHandler.getHeader(
      config.azure_ad_config.apis.OAT.name
    ),
  };
  const response = await fetch(
    `${config.oat_api_url}/user/students/agree/${id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllStudents(state) {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    return await fetch(`${config.oat_api_url}/manage/registration/students/user/students?limit=${state.rowsPerPage}&offset=${state.offset}&sort_column=${state.sort_column}&sort_direction=${state.sort_direction}&search_term=${state.search_term}&selectedGrades=${state.selectedGrades}&selectedLanguages=${state.selectedLanguages}&selectedStartDate=${state.selectedStartDate}&selectedEndDate=${state.selectedEndDate}&is_signin_dates_select=${state.is_signin_dates_select}`, requestOptions).then(APIHandler.handleResponse);
}
async function get_student_paper_enrol_status_counts(state) {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };
    const response = await fetch(`${config.oat_api_url}/manage/registration/students/user/students/status-counts?limit=${state.rowsPerPage}&offset=${state.offset}&sort_column=${state.sort_column}&sort_direction=${state.sort_direction}&search_term=${state.search_term}&selectedGrades=${state.selectedGrades}&selectedLanguages=${state.selectedLanguages}&selectedStartDate=${state.selectedStartDate}&selectedEndDate=${state.selectedEndDate}`, requestOptions);
    return APIHandler.handleResponse(response);
}
 async function get_student_paper_details(student_id){
   const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };
    const response = await fetch(`${config.oat_api_url}/manage/registration/students/user/student/assessments/${student_id}`, requestOptions);
    return APIHandler.handleResponse(response);
 }
 async function get_assessment_student_details(assessment_id){
   const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };
    const response = await fetch(`${config.oat_api_url}/manage/registration/students/user/assessment/students/${assessment_id}`, requestOptions);
    return APIHandler.handleResponse(response);
 }
 
async function get_paper_enroled_student_counts(state) {
  const requestOptions = {
    method: 'GET',
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
  };

  const params = new URLSearchParams({
    limit: state.rowsPerPage,
    offset: state.offset,
    search_term: state.search_term || "",
    sort_column: state.sort_column,
    sort_direction: state.sort_direction,
  });

  const arrayFilters = {
    selectedCategories: state.selectedCategories,
    selectedAuthors: state.selectedAuthors,
    selectedChapters: state.selectedChapters,
    selectedGrades: state.selectedGrades,
    selectedDifficulties: state.selectedDifficulties,
    selectedLanguages: state.selectedLanguages,
    selectedTerms: state.selectedTerms,
    selectedYears: state.selectedYears,
    selectedSubjects: state.selectedSubjects,
    selectedStatuses: state.selectedStatuses,
    selectedExamCategories: state.selectedExamCategories,
  };

  Object.entries(arrayFilters).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      value.forEach(v => params.append(key, v));
    }
  });

  const url = `${config.oat_api_url}/manage/registration/students/user/student/getAllFilteredPublicAssessments/managed?${params.toString()}`;

  const response = await fetch(url, requestOptions);
  return APIHandler.handleResponse(response);
}
